import { fetchSviatky } from '../client/external/ciselniky/sviatokClient';
import { useClientFetch } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import Sviatok from '../model/ciselniky/Sviatok';

interface ReturnType {
  sviatky: Sviatok[];
  sviatkyStatus: ClientStatus;
}

export default (): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(fetchSviatky, [], []);
  return {
    sviatky: data,
    sviatkyStatus: status,
  };
};
